export default () => ({
  log: () => Promise.resolve(),
  recordError: () => Promise.resolve(),
  setCrashlyticsCollectionEnabled: () => Promise.resolve(),
  crash: () => Promise.resolve(),
});
